import formatNumber, { FormatType } from 'helpers/formatNumber';

const getMeasureUnits = (ticks: any, dataType: FormatType): any => {
  const arrayOfTicks = ticks
    .filter((tick: any) => !!tick)
    .map((tick: any) => formatNumber(tick, dataType, true));
  const firstLetter =
    arrayOfTicks.length > 0
      ? arrayOfTicks[arrayOfTicks.length - 1].slice(-1).toLowerCase()
      : '';
  const measures = {
    k: 'thousands',
    m: 'millions',
    b: 'billions',
    t: 'trillions',
  };
  return (measures as any)[firstLetter] || null;
};

export default getMeasureUnits;
